<template>
  <v-container>
    <template>
      <taxRollSummaryCriteria :baseCrudKey="baseCrudKey"
      @loadCRUDList="handleLoadTaxRollSummaryList" />
   <CRUDList
      ref="crudList"
      :canAdd="checkIfItsTmAdmin"
      :canEdit="checkIfItsTmAdmin"
      :canSave="checkIfItsTmAdmin"
      :showSelect="false"
      :enableFixedHeaders="true"
      :displayTopPagination="false"
      :canDeleteInDialog="checkIfItsTmAdmin"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :dialogHeaderName="dialogHeaderName"
      :tableTitle="dialogHeaderName"
      :defaultSortBy="defaultSortBy"
      dialogDynamicWidth="40vw"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='450'
      @emitSelectedItem="emitSelectedItem"
      @upsertItem="upsertRecords"
      @deleteItem="deleteFromDiaglog"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      @loadCRUDList="handleLoadTaxRollSummaryList">
      <template v-slot:[`editedItem`]="{}">
        <taxRollSummaryDialog :baseCrudKey="baseCrudKey" @handleReTotal="handleReTotal"
        :disableReTotal="disableReTotal" />
      </template>
    </CRUDList>
    </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { TaxRollSummaryCollectionHeaders } from '../Utils/taxHeaders.utils';
import taxRollSummaryCriteria from './taxRollSummaryCriteria.vue';
import taxRollSummaryDialog from './taxRollSummaryDialog.vue';
import {
  amountFormat, amountToNumber, defaultGridLoading, manageGridLoading,
} from '../../../util/shared/vue-global';
import { makeCriteriaStateNullIfEmptyString } from '../../tax/common-utils/CommonTaxFunctionalities';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';
import '../../../assets/style.css';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles } from '../../../router/roleGroups';

const amountFields = [
  'originalTax', 'supplements', 'plusAdj', 'minusAdj', 'uncollected', 'adjTax', 'overpaid', 'collections', 'protest',
];
export default {
  name: 'taxRollSummaryList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxRollSummaryCriteria,
    taxRollSummaryDialog,
  },
  created() {
    this.loadConfig({ requiredScope: 'taxConfig' });
  },
  data() {
    return {
      baseCrudKey: 'taxRollSummaryList',
      dialogHeaderName: 'Tax Roll Summary Collection',
      headers: TaxRollSummaryCollectionHeaders,
      gridLoading: defaultGridLoading(),
      isItFirstCallOrNot: false,
      disableReTotal: false,
    };
  },
  mounted() {
    if (this.defaultTaxYearFromTaxSetting) {
      this.isItFirstCallOrNot = true;
      this.handleLoadTaxRollSummaryList();
    }
    // if (this.latestTaxYear) {
    //   this.isItFirstCallOrNot = true;
    //   this.handleLoadTaxRollSummaryList();
    // }
  },
  watch: {
    // latestTaxYear(newVal, oldVal) {
    //   if (newVal && !oldVal) this.criteriaState.taxYear = this.latestTaxYear;
    //   if (newVal !== 0) {
    //     this.isItFirstCallOrNot = true;
    //     this.handleLoadTaxRollSummaryList();
    //   }
    // },
    defaultTaxYearFromTaxSetting(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.taxYear = this.defaultTaxYearFromTaxSetting;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadTaxRollSummaryList();
      }
    },
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      StoreSelItems: (state) => state.shared.taxRollSummaryShared.selectedItems,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    checkIfItsTmAdmin() {
      // only show allow for full access to the super admin
      const isSuperAdmin = isAuthorised(authRoles.SuperAdmin);
      return isSuperAdmin || false;
    },
    defaultSortBy() {
      return [
        {
          column: 'schoolDistrict',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setCriteria', 'setItem']),
    ...mapMutations('shared/taxRollSummaryShared', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/taxRollSummaryShared', [
      'loadTaxRollSummaryCollectionRecords',
      'upserttaxRollSummaryCollection',
      'deletetaxRollSummaryCollection',
      'reTotalTaxRollSummary',
    ]),
    ...mapActions('SystemConfig', ['loadConfig']),
    async handleReTotal(item) {
      this.disableReTotal = true;
      const itemObj = { _id: item._id, taxYear: item.taxYear, schoolDistrict: item.schoolDistrict };
      const results = await this.reTotalTaxRollSummary({
        item: itemObj,
        baseCrudKey: this.baseCrudKey,
      });
      amountFields.forEach((ft) => { results[ft] = amountFormat(results[ft]); });
      this.setItem([this.baseCrudKey, results]);
      this.disableReTotal = false;
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      const itemObj = { ...item };
      amountFields.forEach((f) => {
        itemObj[f] = amountToNumber(itemObj[f]);
      });

      const updatedItem = makeCriteriaStateNullIfEmptyString(itemObj);

      await this.upserttaxRollSummaryCollection({ item: updatedItem, baseCrudKey });
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deletetaxRollSummaryCollection({ item, baseCrudKey });
      }
    },
    handleLoadTaxRollSummaryList() {
      if (this.isItFirstCallOrNot) {
        const { baseCrudKey } = this;
        const criteria = { ...this.criteriaState };
        manageGridLoading(this, true, 'Searching...');
        this.loadTaxRollSummaryCollectionRecords({ criteria, baseCrudKey }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
  },
};
</script>
